import { DOCTYPES } from '@/constants/doctypes'
import { PERMISSIONS } from '@/constants/permissions'
import { createSingleViewRoutes } from '@/routers/routes/createDoctypeRoutes'

const { home: routeEmailConfigurationHome, root: routeEmailConfigurationRoot } =
  createSingleViewRoutes({
    doctypes: {
      [DOCTYPES.TW_EMAIL_CONFIG]: [PERMISSIONS.READ],
    },
    name: 'email-configuration',
    path: 'configuration',
    view: async () =>
      await import('@/components/viewsExternal/settings/email/ViewEmailSettings.vue'),
  })

export { routeEmailConfigurationHome, routeEmailConfigurationRoot }
